import FormSection from './FormSection'
import { translations } from '../../data/translations'

const PrioritiesSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.priorities || translations.de.priorities

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 16.1 Projektziele gewichten */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle1}</div>
        
        <div className="priority-grid">
          {t.priorityItems.map(item => (
            <div key={item.field} className="priority-row" style={{ 
              display: 'grid', 
              gridTemplateColumns: '2fr 1fr', 
              gap: '16px', 
              alignItems: 'center',
              marginBottom: '12px',
              padding: '12px',
              background: 'var(--very-light-teal)',
              borderRadius: '8px'
            }}>
              <label className="priority-label" style={{ fontWeight: '500' }}>{item.label}</label>
              <select
                name={item.field}
                value={formData[item.field] || ''}
                onChange={(e) => updateFormData(item.field, e.target.value)}
                className="priority-select"
                style={{
                  padding: '8px 12px',
                  borderRadius: '6px',
                  border: '2px solid var(--border-color)',
                  fontSize: '0.95rem'
                }}
              >
                <option value="">—</option>
                <option value="1">1 – {t.unwichtig}</option>
                <option value="2">2</option>
                <option value="3">3 – {t.mittel}</option>
                <option value="4">4</option>
                <option value="5">5 – {t.sehrWichtig}</option>
              </select>
            </div>
          ))}
        </div>
      </div>

      {/* 16.2 Entscheidungsgrundlage */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle2}</div>
        
        <div className="form-group">
          <label>{t.entscheidungsgrund}</label>
          <div className="radio-group">
            {t.entscheidungsgrundOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`entsch-${option.value}`}
                  name="entscheidungsgrund"
                  value={option.value}
                  checked={formData.entscheidungsgrund === option.value}
                  onChange={(e) => updateFormData('entscheidungsgrund', e.target.value)}
                />
                <label htmlFor={`entsch-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </FormSection>
  )
}

export default PrioritiesSection
